/* eslint-disable no-restricted-imports */
import { useDepositQueryLazyQuery } from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameFooter/UserFooter/QuickDepositButton/graphql/DepositQuery.generated';
import useCurrencyConfig from '~/client/hooks/currency/useCurrencyConfig';
import useWalletCurrency from '~/client/hooks/currency/useWalletCurrency';
import useIsRtl from '~/client/hooks/useIsRtl';


const useQuickDepositButton = () => {
  const currency = useWalletCurrency();
  const depositCurrency = useCurrencyConfig();
  const { isRtl } = useIsRtl();

  const [getAddress, { data, loading }] = useDepositQueryLazyQuery({
    variables: {
      currency: depositCurrency.name,
    },
    ssr: false,
  });

  const {
    address = '',
    accountAddress = '',
    destinationTag = '',
  } = data?.banking?.myCurrentAddress ?? {};

  const walletInfo = {
    address: currency === 'XRP' ? accountAddress : address,
    destinationTag,
  };

  return { getAddress, loading, walletInfo, currency, isRtl };
};

export default useQuickDepositButton;
